import { render, staticRenderFns } from "./AssistantCreate.vue?vue&type=template&id=71cb7560"
import script from "./AssistantCreate.vue?vue&type=script&lang=js"
export * from "./AssistantCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports